import axios from "axios";
import { BASEURL_API_BAKONG, BASEURL_API_WEBSOCKET, TOKEN_BAKONG } from "../constants";

export const axiosClient = axios.create({baseURL: BASEURL_API_BAKONG});
axiosClient.interceptors.request.use( function (config){
  
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] =  `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : TOKEN_BAKONG}`;
  return config;
},function(error){
  return Promise.reject(error);
});
axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const statusCode = error?.response?.data.responseCode;
  
    if (statusCode === 1 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const  data  : IRenewToken = (await axios.get(BASEURL_API_WEBSOCKET+'/bakong/token')).data;
        localStorage.setItem('token', data.token);

        originalRequest.headers.Authorization = `Bearer ${data.token}`;
        return axiosClient(originalRequest);
      } catch (refreshError) {
        console.error('Token refresh failed', refreshError);
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);


export const axiosInvoiceLess = axios.create({baseURL: 'https://api.invoiless.com/v1'})
axiosInvoiceLess.interceptors.request.use( function (config){
  config.headers['Content-Type'] = 'application/json';
  config.headers['api-key'] = 'rFsnLuEqAsyajMrLFUtZD';
  return config;
},function(error){
  return Promise.reject(error);
})


interface IRenewToken{
  token: string;
  responseCode: number;
}